/*******************************************************************************
 * @ngdoc    object
 * @module   csm.books.services
 * @name     csm.books.services.NewBooksData.type:AccountAdminInfo
 * @constructor
 * @param {object=} info  Item info read from database.
 * @description
 * Account Information for Account Admin or Initial Setup. Inherits from
 * `NewBooksData.AccountInfo`.
 *******************************************************************************/
AccountAdminInfoConfig.$inject = ['TypeFactoryProvider'];
/* @ngInject */ export function AccountAdminInfoConfig(TypeFactoryProvider) {
  TypeFactoryProvider.addType({
    name: 'NewBooksData.accounts.AccountAdminInfo',
    inherits: 'NewBooksData.AccountInfo',
    $type: 'csm.booksdb.data.accounts.AccountAdminInfo, CSMBooksDBCS',
    prototype: {
      description: null, // Description.
      active: true, // Active Flag.
      required: false, // Account Type Required Flag.
      className: null, // Class Name.
      taxCategory: 0, // Account Tax Category.
      groupID: null, // Account Group ID.
      groupDescription: null // Account Group Description.
    },
    defaults: {
      active: true // Active flag must be serialized.
    }
  });
}
